import {ME_REQUEST, ME_SUCCESS, ME_FAILURE, RESET_ME} from '../actions';

export const ME_INITIAL_STATE = {
    name: null,
    roles: [],
    permissions: [],
    isFetching: false
};

const meReducers = {
    [ME_REQUEST]: state => ({...ME_INITIAL_STATE, isFetching: true}),
    [ME_SUCCESS]: (state, {res}) => ({
        ...state,
        ...res,
        isFetching: false
    }),
    [ME_FAILURE]: state => ({...state, isFetching: false}),
    [RESET_ME]: state => ({...ME_INITIAL_STATE})
};

export default function auth(state = ME_INITIAL_STATE, action) {
    let reducer = meReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/me.js